export enum TesterRank {
  Lowest = 1,
  Lower = 2,
  Base = 3,
  Higher = 4,
  Highest = 5,
}
